export const AdminUrls = {
  adminPanel: '/admin',
  health: '/admin/health',
  permissions: '/admin/permissions',
  permissionDetail: (permissionId: string) => `/admin/permissions/${permissionId}`,
  organizations: '/admin/organizations',
  cache: '/admin/cache',
  users: '/admin/users',
  userDetail: (userId: string) => `/admin/users/${userId}`,
  trainers: '/admin/trainers',
  synchronization: '/admin/synchronization',
  loginActivity: '/admin/login-activity',
  invitations: '/admin/invitations'
} as const;

export type AdminUrl = (typeof AdminUrls)[keyof typeof AdminUrls];
